import { computed } from 'vue';
import { CampaignMandatoryFieldsValidator } from '@studyportals/campaign-management-api-interface';
import { IValidationInfoDates, ValidationProperties } from '@/models/validation.interface';
import { ValidationResult } from '@studyportals/campaign-management-api-interface';
import { HttpErrorResponse } from '@/models/error.interface';
import savingValidationPayloadPresenter from '@/presenters/saving-validation-payload-presenter';
import store from '@/store';

class ValidationPresenter {

	private validationResult = computed((): ValidationResult => {
		return store.getters.validationResult();
	});

	public isPropertyMissing(property: ValidationProperties): boolean {
		return this.validationResult.value.missing.includes(property);
	}

	public isPropertyInvalid(property: ValidationProperties): boolean {
		return this.validationResult.value.invalid.includes(property);
	}

	public validateMandatoryFields(): void {
		const payload = savingValidationPayloadPresenter.createValidationPayload();
		const validationResult = CampaignMandatoryFieldsValidator.validate(payload);

		store.mutations.setValidationResult(validationResult);
	}

	public updateValidationInfoDates(error: HttpErrorResponse): void {
		const validationInfo: IValidationInfoDates = {
			message: '',
			invalidTypes: []
		};

		const errorResponse = JSON.parse(error.response?.text ?? '{ "message": "" }') as Error;
		switch (errorResponse.message) {
			case 'New end date is before or at start date.':
				validationInfo.message = 'The end date must be after the start date.';
				validationInfo.invalidTypes = [ValidationProperties.START_DATE, ValidationProperties.END_DATE];
				break;
			case 'New start date is in the past.':
				validationInfo.message = 'The start date must be either today or a date in the future.';
				validationInfo.invalidTypes = [ValidationProperties.START_DATE];
				break;
			case 'New end date is in the past.':
				validationInfo.message = 'The end date must be either today or a date in the future.';
				validationInfo.invalidTypes = [ValidationProperties.END_DATE];
				break;
			case 'Change start date from today or past is not allowed.':
				validationInfo.message = 'The start date has already passed and can no longer be changed.';
				validationInfo.invalidTypes = [ValidationProperties.START_DATE];
				break;
			case 'Change end date from today or past is not allowed.':
				validationInfo.message = 'The end date has already passed and can no longer be changed.';
				validationInfo.invalidTypes = [ValidationProperties.END_DATE];
				break;
			default:
				return;
		}

		store.mutations.setValidationInfoDates(validationInfo);
	}
}

export default new ValidationPresenter();
